import { useCallback } from 'react';
import { useSetAtom } from 'jotai';

import { useReferralVariant } from './use-referral-variant';
import { referralInviteModalAtom, ReferralInviteSource } from './referral-modal.atoms';
import { useV2Router } from '../dashboard/hooks/use-v2-router';

const REFERRAL_PAGE_PATH = '/employer/referral';

// Single branch point for the referral-ux-variant experiment.
// All referral CTAs call this hook — none of them know about the flag directly.
//
// To remove this experiment:
//   modal wins → replace callers with useSetAtom(referralInviteModalAtom) directly, delete this file + use-referral-variant.ts
//   page wins  → replace callers with router.push(REFERRAL_PAGE_PATH), delete modal files + this file + use-referral-variant.ts
export const useOpenReferralInvite = () => {
  const variant = useReferralVariant();
  const setModal = useSetAtom(referralInviteModalAtom);
  const router = useV2Router();

  return useCallback(
    (source: ReferralInviteSource) => {
      if (variant === 'modal') {
        setModal({ isOpen: true, source });
      } else {
        void router.push(REFERRAL_PAGE_PATH);
      }
    },
    [variant, setModal, router]
  );
};
